// src/stores/sessionStore.tsx
import { create } from "zustand";

// Define the session type based on your NextAuth.js configuration in authOptions.ts
interface SessionUser {
  id: number;
  first_project: number;
  uid?: string;
  first_name?: string | null;
  avatar?: string | null;
  name?: string | null; // Changed to optional and nullable to match NextAuth
  email?: string | null;
  token?: string;
  remember?: boolean;
}

interface Session {
  user?: SessionUser;
  expires?: string;
}

interface SessionState {
  session: Session | null;
  setSession: (session: Session | null) => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  session: null,
  setSession: (session: Session | null) => set({ session }),
}));